/* eslint-disable react-hooks/exhaustive-deps */
import { createContext, useEffect, useState } from "react";
import { ethers, utils } from "ethers";

import ConnectWalletModal from "../components/ConnectWalletModal";
import WalletConnectProvider from "@walletconnect/web3-provider";

import GlobalStyles from "./globalStyles";
import { useCallback, useMemo } from "react";

const AppContext = createContext(null);
const { ethereum } = window;

const AppContextProvider = ({ children, theme, setTheme }) => {
  const initState = {
    user: {
      address: ethereum?.selectedAddress || "",
      balance: "0.0000",
    },
    loading: true,
    provider: null,
    netWork: null,
    wrongNetwork: false,
    contracts: {
      nft: {
        contract: null,
        data: {
          items: [],
          seletedNFT: null,
          lockedNFT: null,
          boostingPercentage: 0,
        },
        forceClass: "",
      },
      lpToken: {
        contract: null,
        data: {
          balance: "0.0000",
          fullBalance: "0",
        },
      },
      staking: {
        contract: null,
        data: {
          list: [],
          transactionsList: [],
          stakedDetails: {
            lockedLPs: "0.0000",
            totalLPs: "0.0000",
            nextUlocke: "00:00:00",
            unlockedLPs: "0.0000",
            unlocekdRewards: "0.0000",
            nftUnlockedDate: "N / A",
          },
          stakingRewards: "0.0000",
          stakeAgain: false,
        },
      },
    },
    getShortenAddress: (address) =>
      address.substring(0, 6) + "..." + address.substring(address.length - 4),
    connectWallet: () => setConnectWalletModal(true),
  };
  const [state, setStates] = useState(initState);
  const setState = (newState) => setStates({ ...state, ...newState });
  const [nftItems, setNftItems] = useState([]);
  const [connectWalletModal, setConnectWalletModal] = useState(false);

  const getContract = async (url, address, walletConnectProvider) => {
    if (ethereum || walletConnectProvider) {
      try {
        const contractFile = await fetch(url);
        const convertContractFileToJson = await contractFile.json();

        const provider = new ethers.providers.Web3Provider(
          walletConnectProvider || ethereum
        );
        const signer = provider.getSigner();
        return new ethers.Contract(address, convertContractFileToJson, signer);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const getStakingList = async (
    contract = state.contracts.staking.contract
  ) => {
    const stakeholderData = await contract.getStakeholderStakingList(0, 100);
    const { nftBoostingPeriod_ } = await contract.getStakeholderStats();

    const status = ["Claimed", "Locked", "Unlocked"];
    const transactions = [];
    for (var i = 0; i < stakeholderData.length; i++) {
      const transaction = {
        stakeID: i,
        stakedLPs: parseFloat(stakeholderData[i].stakedLPs / 1e18).toFixed(4),
        stakingPeriodName: stakeholderData[i].stakingPeriodName.toString(),
        stakingRewards: parseFloat(
          stakeholderData[i].stakingRewards / 1e16
        ).toFixed(4),
        APR: parseFloat(stakeholderData[i].APR),
        unlockedDate: new Date(
          stakeholderData[i].unlockedDate.toString() * 1000
        ).toLocaleString(),
        lockedDate: new Date(
          stakeholderData[i].lockedDate.toString() * 1000
        ).toLocaleString(),
        unlockedDateTimestamp:
          stakeholderData[i].unlockedDate.toString() * 1000,
        lockedDateTimeStamp: stakeholderData[i].lockedDate.toString() * 1000,
        status: status[stakeholderData[i].status],
        boostingPeriod: parseFloat(nftBoostingPeriod_) * 1000,
        boostNFT: stakeholderData[i].boostNFT,
        boostingPercentage: parseFloat(stakeholderData[i].boostingPercentage),
        isBoost:
          stakeholderData[i].boostNFT ===
          "0x0000000000000000000000000000000000000000"
            ? false
            : true,
      };
      transactions.push(transaction);
    }

    return transactions;
  };

  const updateStakeholderData = async (
    stakingContract = state.contracts.staking.contract
  ) => {
    const { stakeholderData_ } = await stakingContract.getStakeholderStats();

    return {
      lockedLPs: parseFloat(
        (stakeholderData_.totalStakedLPs -
          stakeholderData_.unlockedLPs -
          stakeholderData_.claimedLPs) /
          10 ** 18
      ).toFixed(4),
      totalLPs: parseFloat(stakeholderData_.totalStakedLPs / 10 ** 18).toFixed(
        4
      ),
      nextUlocke:
        Number(stakeholderData_.nextUnlockDate.toString()) === 0
          ? "No Locked Balance"
          : new Date(
              stakeholderData_.nextUnlockDate.toString() * 1000
            ).toLocaleString(),

      unlockedLPs: parseFloat(stakeholderData_.unlockedLPs / 10 ** 18).toFixed(
        4
      ),
      unlocekdRewards: parseFloat(
        stakeholderData_.unlockedRewards / 10 ** 18
      ).toFixed(4),
      nftUnlockedDate:
        Date.now() > stakeholderData_.lockedNFTsList[0]?.unlockDate * 1000
          ? "N / A"
          : new Date(
              stakeholderData_.lockedNFTsList[0]?.unlockDate * 1000
            ).toLocaleString(),
    };
  };

  const getLPBalance = async (
    lpTokenContract = state.contracts.lpToken.contract,
    address = state.user.address
  ) => {
    const balance = await lpTokenContract.balanceOf(address);

    return Number(balance.toString()).toFixed(4);
  };

  const getWeb3 = async (account, walletConnectProvider) => {
    if (ethereum || walletConnectProvider) {
      try {
        const provider = new ethers.providers.Web3Provider(
          walletConnectProvider || ethereum,
          "any"
        );

        let address = account || ethereum.selectedAddress;
        if (!address) {
          const addressRequest = await window.ethereum.request({
            method: "eth_requestAccounts",
          });

          address = addressRequest[0];
        }

        let netWork = await provider.getNetwork();
        if (netWork.chainId !== Number(process.env.REACT_APP_CHAIN_ID)) {
          await updateNetWork();
          netWork = await provider.getNetwork();
        }

        const balanceSelectedAddress = await provider.getBalance(address);

        // staking contract
        const stakingContract = await getContract(
          "/abi/staking-contract.json",
          process.env.REACT_APP_STAKING_CONTRACT,
          walletConnectProvider
        );
        const stakingList = await stakingContract.getStakingPeriodsList();
        const lockedNFTInfo = await stakingContract.getLockedNFTInfo(
          process.env.REACT_APP_CONTRACT_ADDRESS
        );
        const stakeholderData_ = await updateStakeholderData(stakingContract);
        const transactions = await getStakingList(stakingContract);

        // nft contract
        const nftContract = await getContract(
          "/abi/nft-contract.json",
          process.env.REACT_APP_CONTRACT_ADDRESS,
          walletConnectProvider
        );
        const totalNftOwend = await nftContract.balanceOf(address);
        let lockedNFTsList;
        let getApprovedAddress = "0x0000000000000000000000000000000000000000";

        const { lockedNFTsList_ } = await stakingContract.getLockedNFTsList();
        if (
          lockedNFTsList_[0].smartContractAddress !==
          "0x0000000000000000000000000000000000000000"
        ) {
          lockedNFTsList = lockedNFTsList_[0];
        }

        const nNftItemsLooped = [
          ...Array(Number(totalNftOwend.toString())).keys(),
        ].map(async (index) => {
          const tokenId = await nftContract.tokenOfOwnerByIndex(address, index);
          const url = await nftContract.tokenURI(tokenId);

          if (url.split(".")[url.split(".").length - 1] === "json") {
            const response = await fetch(url);
            const data = await response.json();

            return {
              tokenID: tokenId,
              url: data.image,
              name: data.name,
            };
          }

          return {
            tokenID: tokenId,
            url: url,
          };
        });

        const nftItemsData = await Promise.all(nNftItemsLooped);
        setNftItems(nftItemsData);

        // lp token contract
        const lpTokenContract = await getContract(
          "/abi/lp-token-contract.json",
          process.env.REACT_APP_LP_CONTRACT_ADDRESS,
          walletConnectProvider
        );
        const balance = await getLPBalance(lpTokenContract, address);
        const fullBalance = await lpTokenContract.balanceOf(address);

        setState({
          provider,
          netWork,
          user: {
            ...state.user,
            address,
            balance: String(utils.formatUnits(balanceSelectedAddress)).match(/^-?\d+(?:\.\d{0,4})?/)?.[0],
          },
          contracts: {
            ...state.contracts,
            nft: {
              contract: nftContract,
              data: {
                ...state.contracts.nft.data,
                seletedNFT: lockedNFTsList,
                getApprovedAddress,
                lockedNFT: lockedNFTsList,
              },
            },
            lpToken: {
              contract: lpTokenContract,
              data: {
                ...state.contracts.lpToken.data,
                balance,
                fullBalance
              },
            },
            staking: {
              contract: stakingContract,
              data: {
                ...state.contracts.staking.data,
                list: stakingList,
                boostingPercentage:
                  lockedNFTInfo.boostingPercentage_.toString(),
                transactionsList: transactions,
                stakedDetails: stakeholderData_,
              },
            },
          },
          loading: false,
        });
      } catch (error) {
        console.log(error);
        const provider = new ethers.providers.Web3Provider(
          walletConnectProvider || ethereum,
          "any"
        );
        const netWork = await provider.getNetwork();

        setState({
          loading: false,
          netWork,
        });
      }
    }
  };

  const updateNetWork = async () => {
    if (!ethereum) {
      alert("wrong network you need to switch to mainnet");

      return;
    }
    try {
      await ethereum.request({
        method: "wallet_switchEthereumChain",
        params: [
          {
            chainId: `0x${Number(process.env.REACT_APP_CHAIN_ID).toString(16)}`,
          },
        ],
      });
    } catch (error) {
      try {
        await ethereum.request({
          method: "wallet_addEthereumChain",
          params: [
            {
              chainName: process.env.REACT_APP_CHAIN_NAME,
              chainId: `0x${Number(process.env.REACT_APP_CHAIN_ID).toString(
                16
              )}`,
              rpcUrls: [process.env.REACT_APP_CHAIN_RPC_URL],
              nativeCurrency: {
                name: process.env.REACT_APP_CHAIN_CURRENCY_SYMBOL,
                symbol: process.env.REACT_APP_CHAIN_CURRENCY_SYMBOL,
                decimals: 18,
              },
              blockExplorerUrls: [
                process.env.REACT_APP_CHAIN_BLOCK_EXPLORER_URL,
              ],
            },
          ],
        });
      } catch (error) {
        console.log(error);
      }
    }
  };

  const disconnect = async () => {
    if (ethereum?.selectedAddress) {
      setState({
        ...initState,
        user: {
          address: "",
          balance: "0.0000",
        },
        loading: false,
      });
    } else if (localStorage.connectStatus === "2") {
      const provider = new WalletConnectProvider({
        rpc: {
          [process.env.REACT_APP_CHAIN_ID]: process.env.REACT_APP_CHAIN_RPC_URL,
        },
        bridge: "https://bridge.walletconnect.org",
      });

      await provider.disconnect();
      localStorage.removeItem("connectStatus");
      setState({
        ...initState,
        user: {
          address: "",
          balance: "0.0000",
        },
        loading: false,
      });
    }
  };

  useEffect(() => {
    if (nftItems.length === 0 || state.contracts.nft.lockedNFT?.tokenID || !state.contracts.nft.contract) return;

    nftItems.forEach(async (item) => {
      const getApprovedAddress =
        await state.contracts.nft.contract?.getApproved(
          item.tokenID.toString()
        );

      if (getApprovedAddress === process.env.REACT_APP_STAKING_CONTRACT) {
        setState({
          contracts: {
            ...state.contracts,
            nft: {
              ...state.contracts.nft,
              data: {
                ...state.contracts.nft.data,
                seletedNFT: nftItems.find(
                  (nftItem) =>
                    nftItem.tokenID.toString() === item.tokenID.toString()
                ),
              },
            },
          },
          loading: false,
        });
      }
    });
  }, [nftItems, state.contracts.nft.contract]);

  const getConnectedStatus = useCallback(async () => {
    if (ethereum?.selectedAddress) {
      getWeb3(ethereum?.selectedAddress);
    } else if (localStorage.connectStatus === "2") {
      const provider = new WalletConnectProvider({
        rpc: {
          [process.env.REACT_APP_CHAIN_ID]: process.env.REACT_APP_CHAIN_RPC_URL,
        },
        bridge: "https://bridge.walletconnect.org",
      });
      const connected = await provider.enable();

      getWeb3(connected[0], provider);
      provider.on("accountsChanged", (accounts) => {
        if (state.user.address !== accounts[0]) {
          setState({ loading: true });
          getWeb3(accounts[0], provider);
        }
      });

      provider.on("chainChanged", async (chainId) => {
        if (chainId !== Number(process.env.REACT_APP_CHAIN_ID)) {
          await provider.disconnect();
        }
      });

      provider.on("disconnect", () => {
        setState({
          ...initState,
          loading: false,
        });
        localStorage.connectStatus = 0;
      });
    } else {
      setState({ loading: false });
    }
  }, [ethereum]);

  useEffect(() => {
    getConnectedStatus();
  }, [ethereum?.selectedAddress]);

  useEffect(() => {
    if (!ethereum) return;

    ethereum.on("accountsChanged", async (account) => {
      if (!account[0]) {
        setState({
          ...initState,
          user: {
            address: "",
            balance: "0.0000",
          },
          loading: false,
        });

        return;
      } else {
        setState({ loading: true });

        getWeb3(account[0]);
      }
    });

    ethereum.on("chainChanged", async (chainId) => {
      if (parseInt(chainId, 16) !== Number(process.env.REACT_APP_CHAIN_ID)) {
        setState({
          loading: false,
          netWork: {
            ...state.netWork,
            chainId,
          },
        });
      } else {
        if (state.user.address) {
          setState({
            loading: true,
            netWork: {
              ...state.netWork,
              chainId,
            },
          });
          getWeb3();
        }
      }
    });

    ethereum.on("disconnect", () => {
      setState({
        ...initState,
        user: {
          address: "",
          balance: "0.0000",
        },
        loading: false,
      });
    });

    return () => ethereum.removeAllListeners();
  }, []);

  useEffect(() => {
    const getNetwork = async () => {
      const provider = new ethers.providers.Web3Provider(ethereum);

      const netWork = await provider.getNetwork();
      setState({
        netWork,
        ...(ethereum.selectedAddress ? {} : { loading: false }),
      });
    };

    ethereum && getNetwork();
  }, []);

  const api = useMemo(
    () => ({
      getWeb3,
      state,
      initState,
      nftItems,
      theme,
      setTheme,
      disconnect,
      updateNetWork,
      getStakingList,
      updateStakeholderData,
      getLPBalance,
      setState,
    }),
    [
      getWeb3,
      state,
      initState,
      nftItems,
      theme,
      setTheme,
      disconnect,
      updateNetWork,
      getStakingList,
      updateStakeholderData,
      getLPBalance,
      setState,
    ]
  );

  return (
    <AppContext.Provider value={api}>
      <div className="bootstrap-wrapper">
        <ConnectWalletModal
          connectWalletModal={connectWalletModal}
          setConnectWalletModal={setConnectWalletModal}
        />
        <GlobalStyles />
        {state.loading ? (
          <div className="loading-wrapper">
            <div className="lds-ring">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        ) : (
          children
        )}
      </div>
    </AppContext.Provider>
  );
};

export { AppContext, AppContextProvider };
